<details class="collapsable-info-block card-footer border-top p-0 pt-2">
  <summary
    class="collapsable-info-block__summary d-flex cursor-pointer"
    wlAutomationId="collapsable-info-block"
  >
    @if (type === 'info') {
      <fa-icon class="icon icon--info text-primary me-1" icon="circle-info">
      </fa-icon>
    }
    @if (type === 'warning') {
      <fa-icon
        class="icon icon--info text-warning me-1"
        icon="exclamation-triangle"
      ></fa-icon>
    }
    @if (type === 'danger') {
      <fa-icon
        class="icon icon--info text-danger me-1"
        icon="exclamation-triangle"
      >
      </fa-icon>
    }
    <span>{{ title }}</span>
    <fa-icon
      icon="chevron-down"
      class="icon icon--info text-primary ms-auto flex chevron"
    ></fa-icon>
  </summary>
  <ng-content></ng-content>
</details>
